"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isValidIssuer = exports.hasRefreshTokenExpired = exports.hasExpired = exports.getAuthMessage = exports.GrantType = exports.expirybufferSeconds = void 0;
const constant_1 = require("../constant");
const dayjs_1 = __importDefault(require("dayjs"));
const evm_1 = require("./evm");
exports.expirybufferSeconds = 30;
var GrantType;
(function (GrantType) {
    GrantType["SignatureCosmos"] = "signature_cosmos";
    GrantType["SignatureEth"] = "signature_eth";
    GrantType["RefreshToken"] = "refresh_token";
})(GrantType = exports.GrantType || (exports.GrantType = {}));
const getAuthMessage = () => {
    const timestamp = dayjs_1.default().format('YYYY/MM/DD HH:mm:ss Z');
    return `${evm_1.DEFAULT_PUBLIC_KEY_MESSAGE}\n[${timestamp}]`;
};
exports.getAuthMessage = getAuthMessage;
const hasExpired = (exp = 0) => {
    const currentUnix = dayjs_1.default().unix();
    return (currentUnix + exports.expirybufferSeconds) >= exp;
};
exports.hasExpired = hasExpired;
const hasRefreshTokenExpired = (refreshToken) => {
    const payloadStr = refreshToken.split('.')[1];
    if (!payloadStr)
        return true;
    const payload = JSON.parse(Buffer.from(payloadStr, 'base64').toString());
    return exports.hasExpired(payload.exp);
};
exports.hasRefreshTokenExpired = hasRefreshTokenExpired;
const isValidIssuer = (iss = '', network) => {
    switch (network) {
        case constant_1.Network.MainNet:
            return iss === 'demex-auth';
        case constant_1.Network.DevNet:
            return iss === 'demex-auth-dev';
        case constant_1.Network.TestNet:
            return iss === 'demex-auth-test';
        default:
            return iss === 'demex-auth-local';
    }
};
exports.isValidIssuer = isValidIssuer;
